/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([ 'jquery', 'underscore', '../../../../../lib/@waca/core-client/js/core-client/ui/core/Class'], function($, _, Class) {



	var Feature = null;
	Feature = Class.extend({
		init: function(layout) {
			this.layoutView = layout;
			this._events = [
				this.layoutView.content.on('add:child', this.onContentAddItem, this),
				this.layoutView.model.on('add:item', this.onModelAddItem, this),
				this.layoutView.model.on('remove:item', this.onModelRemoveItem, this),
				this.layoutView.model.on('change:parent', this.onModelUpdateParent, this),
				this.layoutView.model.on('change:style', this.onModelUpdateStyle, this),
				this.layoutView.model.on('change:css', this.onModelUpdateCSS, this),
				this.layoutView.model.on('change:fillColor', this.onModelFillColorChange, this)
			];
		},

		_isTypeRegistered: function(type) {
			const contentTypeRegistry = this.layoutView.dashboardApi.getFeature('ContentTypeRegistry');
			return contentTypeRegistry ? contentTypeRegistry.isTypeRegistered(type) : false;
		},

		/**
		 * Called when the fill color changes.
		 * This will notify all descendant widget in case they want o react to the color change
		 */
		onModelFillColorChange: function(payload){

			// Update the fill color css.
			if(payload.prevValue){
				this.layoutView.$el.removeClass('fill-' + payload.prevValue);
			}

			if(payload.value){
				this.layoutView.$el.addClass('fill-' + payload.value);
			}

			// Find all descendant widgets and notify them of the fill color change
			_.each(this.layoutView.model.findDescendantsWithType('widget'), function(widgetModel){
				var view = this.layoutView.layoutController.getLayoutView(widgetModel.id);
				if (view && view.notifyWidget){
					view.notifyWidget('layout:fillColorChange', { data: payload.data });

				}
			}.bind(this));

		},

		onContentAddItem: function(payload) {
			const {
				newContentId,
				parentId,
				value
			} = payload.info;

			const type = value.type || value.spec.type;
			if (!this._isTypeRegistered(type)) {
				// if this is not a custom type, do nothing.
				// The creation of the layout and rendering will be handled as part of the "add:item" model event
				// for more details @see CommonAuthoringFeature::onModelAddItem
				return Promise.resolve();
			}

			const layoutController = this.layoutView.layoutController;
			const parentLayout = layoutController.viewsMap[parentId].view;
			const addItemPromise = layoutController.createLayoutModule(newContentId, parentLayout, {
				addPayloadData: payload.transactionToken
			});

			addItemPromise.then((layoutView) => {
				// Once the view is created, get the node and add it to the parent view.
				parentLayout.add(layoutView, value.insertBefore);
				return layoutView.renderContent();
			});

			if (this.layoutView.onItemAddDone) {
				addItemPromise.then(this.layoutView.onItemAddDone.bind(this.layoutView, payload));
			}

			return addItemPromise;
		},

		/**
		 * Called when a new item is added to the model. The
		 * @param {object}  Event payload that contains the model to be added.
		 */
		onModelAddItem: function(payload) {

			if (this._isTypeRegistered(payload.value.parameter.model.type)) {
				// if this is a custom type, do nothing.
				// The creation of the layout and rendering will be handled as part of the "add:content" content event
				// for more details @see CommonAuthoringFeature::onContentAddItem
				return Promise.resolve();
			}

			var modelJson = payload.value.parameter.model;
			var addItemPromise = this.layoutView.layoutController.createLayoutModule(modelJson.id, this.layoutView, { addPayloadData:payload.data });
			addItemPromise.then((layoutView) => {
				// Once the view is created, get the node and add it to the parent view.

				// The parent could have changed as we are creating the view (e.g. multiple operation on the model.. create then move)
				// We will use the parent set in the view if not we default to this view.
				const parent = layoutView.parentLayout || this.layoutView;
				parent.add(layoutView, payload.value.parameter.insertBefore, payload);
				return layoutView.renderContent();
			});

			if (this.layoutView.onItemAddDone){
				addItemPromise.then(this.layoutView.onItemAddDone.bind(this.layoutView, payload));
			}

			return addItemPromise;
		},

		/**
		 * Called when a layout model is removed
		 * @param eventPayload
		 */
		onModelRemoveItem: function(eventPayload) {
			var sModelId = eventPayload.value.parameter;
			var n = document.getElementById(this.layoutView.getNodeId(sModelId));
			if( n ) {
				var layout = n._layout;
				if( layout ) {
					if (layout.parentLayout){
						layout.parentLayout.removeChild(layout, eventPayload);
					}
					layout.destroy(eventPayload);
				}
			}
		},

		/**
		 * Update the view to reflect changes in the model when the parent changes
		 * @param eventPayload
		 */
		onModelUpdateParent: function(eventPayload) {
			var parameter = eventPayload.value.parameter;
			var parentId = parameter.parentId;

			// Need to check if current parentNode isn't a page (page is a container for widgets).
			// parentLayout.id can be set to a valid layout, but parentNode be <body> in case of dragging. We want to restore the parent when dragging is done/cancel.
			var $isCurrentParentAPage = $(this.layoutView.domNode.parentNode).hasClass('page');

			// We want to update the model only when:
			// 1. current parent isn't a page
			// 2. new parent and current parent don't match
			// 3. if same parent before and after, but we get a hint where to insert it (moving within the parent using insertBefore)
			if (!$isCurrentParentAPage || !this.layoutView.parentLayout || parentId !== this.layoutView.parentLayout.id || parameter.insertBefore !== undefined) {

				// Get the focus node to give back focus after we move the node
				var $focus = $(':focus');
				$(this.layoutView.domNode).detach();

				var attachLayout = function(layout) {
					var insertBefore = parameter.insertBefore;
					this.layoutView.parentLayout = layout;
					layout.add(this.layoutView, insertBefore, eventPayload);
					if (!$isCurrentParentAPage) { //If we are inserting from outside a page, re-apply any existing model styles to the node. This fixes issues where the node was used for another purpose (like an avatar) where the styles were altered for that use.
						const originalStyle = _.extend({}, this.layoutView.model.style);
						const $node = $(this.layoutView.domNode);
						this._updateStyleForNode($node, originalStyle);
					}
					// TODO: We should revisit the solution to RTC 284985 and see if we can eliminate the following condition & onResize
					// As it may not be necessary anymore.
					if (eventPayload.sender === 'UndoRedoController') {
						this.layoutView.onResize(eventPayload);
					}
					$focus.focus();

					//for unit testing
					if (this._onModelUpdateParent) {
						this._onModelUpdateParent();
					}
				}.bind(this);

				// Make sure that the parent view is created and ready
				var parentLayout = this.layoutView.layoutController.getLayoutView(parentId);
				if (parentLayout) {
					// onModelUpdateParent should be synchronous if possible.
					// TODO: Revisit the async case below, for 188827 (group case)
					attachLayout(parentLayout);
				} else {
					// wait for it
					this.layoutView.layoutController.layoutReady(parentId).done(attachLayout);
				}
			}
		},

		/**
		 * Update the view to reflect changes in the model when the style has changed
		 * @param eventPayload
		 */
		onModelUpdateStyle: function(eventPayload){
			var styles = eventPayload.value.parameter;
			var $node = $(this.layoutView.domNode);

			this.saveOriginalNodeDimension();
			this._updateStyleForNode($node, styles, eventPayload.sender);

			if ((styles.height || styles.width) && eventPayload.data.triggerResize!==false) {
				this.layoutView.onResize(eventPayload);
			}
		},

		/**
		 * Update a specific node with the styles passed in.
		 * @param $node jquery element
		 * @param styles CSS styles from an event payload
		 * @param {string} sender Name of the event's sender, needed to check for Undo/Redo.
		 */
		_updateStyleForNode: function($node, styles, sender) {
			var value;
			for(var name in styles){
				if (styles.hasOwnProperty(name) && typeof styles[name] !== 'function') {
					value = styles[name];
					if ((name === 'height' || name === 'width')){
						// If the style value is empty for either height or width and the sender is the undo/redo controller
						// we use the default height and width that we saved.
						if (!value && (sender === 'UndoRedoController')){
							value = (name === 'height' ? this._originalHeight: this._originalWidth) + 'px';
						} else if (!value) {
							this._originalHeight = null;
							this._originalWidth = null;
						}
					}
					$node.css(name, value);
				}
			}
		},

		/**
		 * Update the view to reflect changes in the model when the CSS has changed
		 * @param eventPayload
		 */
		onModelUpdateCSS: function( eventPayload ){

			// get values
			var CSS = eventPayload.value;
			var prevCSS = eventPayload.prevValue;
			var $node = $(this.layoutView.domNode);

			// remove prev class and add new
			$node.removeClass( prevCSS );
			$node.addClass( CSS );
		},

		destroy: function(){
			if(this._events) {
				for (var i = 0; i < this._events.length; i++) {
					if (this._events[i]) {
						this._events[i].remove();
					}
				}
			}
			this._events = null;
		},
		saveOriginalNodeDimension: function(){
			// Save the original height and width so that we can reuse them if an undo is done and the height/width style values are empty
			if(!this._originalHeight){
				var $node = $(this.layoutView.domNode);
				this._originalHeight = $node.height();
				this._originalWidth = $node.width();
			}
		},

		onResizeStep: function(){
			this.saveOriginalNodeDimension();
		}
	});

	return Feature;

});
